import React from 'react';
import { APIHOST, HRHOST } from '../../config';
import Form from 'antd/lib/form';
import AntdFormItem from 'antd/lib/form/FormItem';
import notification from 'antd/lib/notification';
import Select from 'antd/lib/select';
import Axios from 'axios';
import styled from 'styled-components';
import { nanoid } from 'nanoid';
import { Flex, Box } from '../../components/Flex';
import { Text } from '../../components/Text';
import promoteIcon from '../../images/people@2x.png';
import { GradientButton } from '../../components/buttons';
import Banner from './Banner';
import templates from './templates';

const FormItem = styled(AntdFormItem)`
  margin-bottom: 8px;
  & .ant-form-item-label label {
    color: #666;
    font-weight: 600;
  }

  & .ant-form-item-required:before {
    // remove the red '*' required symbol
    display: none;
  }

  & .ant-form-item-label label:after {
    // remove the ':' after the field label
    display: none;
  }
`;

const { Option, OptGroup } = Select;

class Signup extends React.Component {
  constructor(props) {
    super(props);
    const options = templates.map((template) => (
      <Option value={template.title} template={template} key={template.title}>
        {template.title}
      </Option>
    ));

    this.state = {
      phoneNumber: '',
      regionNumber: '',
      phoneNumberValidateStatus: true,
      confirmPwdError: undefined,
      isSubmitting: false,
      options,

      // data
      email: '',
      guestId: nanoid(),
    };
  }

  componentDidMount() {
    this.logSignupEvent({ step: 1 });
  }

  logSignupEvent({ step, email }) {
    const data = {
      page_url: window.location.href,
      guest_id: this.state.guestId,
      anonymous_id: this.state.guestId,
      step_number: step,
      ...(email && { email }),
      is_final_step: false,
    };
    const config = {
      method: 'post',
      url: `${APIHOST}/v1/segment_tracks/visit_self_serve_sign_up`,
      data,
    };
    Axios(config);
  }

  handleClickSignup() {
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const config = {
        method: 'post',
        url: `${APIHOST}/v1/sessions/sign_up`,
        data: {
          anonymous: true,
        },
      };
      this.setState({ isSubmitting: true });
      Axios(config)
        .then((response) => {
          this.setState({ isSubmitting: false });
          const {
            auth_token,
            user: { id: userId },
          } = response.data;
          // Segment.com track
          const { password: pwd, confirm_password: cfm_pwd, ...trackData } = config.data;
          if (window.analytics) {
            // eslint-disable-next-line
            analytics.identify(userId, trackData, () => {
              // eslint-disable-next-line
              analytics.track('Self Serve Signup', trackData, () => {
                window.location.href = `${HRHOST}/#/redirect?type=self_serve_signup&token=${auth_token}&title=${values.position.title}&anonymous_id=${this.state.guestId}`;
              });
            });
          } else {
            window.location.href = `${HRHOST}/#/redirect?type=self_serve_signup&token=${auth_token}&title=${values.position.title}&anonymous_id=${this.state.guestId}`;
          }
        })
        .catch((err) => {
          this.setState({ isSubmitting: false });
          let errorMessage = 'Please contact help@workstream.is for details.';
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          }
          notification.error({
            message: 'Something went wrong',
            description: errorMessage,
          });
        });
    });
  }

  handleChange(value) {
    const options = templates
      .filter((template) => {
        const { title } = template;
        return title.toLowerCase().indexOf(`${value}`.toLowerCase()) !== -1;
      })
      .map((template, index) => {
        return (
          <Option value={template.title} template={template} key={index}>
            {template.title}
          </Option>
        );
      });
    this.setState({ options });
  }

  updatePhoneNumber(status, value, countryData) {
    const regionNumber = countryData.dialCode;
    let phoneNumber = value;

    if (phoneNumber.indexOf('+') !== -1) {
      phoneNumber = phoneNumber.replace(`+${regionNumber}`, '');
    }

    this.setState({
      phoneNumber,
      regionNumber,
      phoneNumberValidateStatus: status,
      phoneNumberErrorMsg: '',
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Flex flexDirection="column" alignItems="center">
        <Banner />
        <Flex
          mt={[0, 87]}
          height={['auto']}
          boxShadow={['none', '0px 2px 14px rgba(13, 140, 230, 0.0962692)']}
          borderRadius={[0, '5px']}
          bg="white"
          justifyContent="center"
          width={['100%', 'auto']}
          maxWidth={747}
          px={['0', '66px']}
        >
          {/* Workstream Setup */}
          <Box pt={82} mr={84} display={['none', 'block']}>
            <img src={promoteIcon} alt="workstream-illustration" width="245" />
          </Box>

          {/* Form part */}
          <Flex column pt={[34, 52]} pb={55}>
            <Flex flexDirection="column" width="290px">
              <Box mt={26}>
                {/* title */}
                <Flex justifyContent={['center', 'flex-start']} column>
                  <Text fontSize="24px">Hello,</Text>
                  <Text fontSize="24px" semibold>
                    Welcome to Workstream!
                  </Text>
                </Flex>
                <Box mt={56} display={['block', 'none']}>
                  <img src={promoteIcon} alt="workstream-mobile" width="245" />
                </Box>
              </Box>
              <Flex column mt={28}>
                <FormItem label="Job title">
                  {getFieldDecorator('position[title]', {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: 'Please input your Position title',
                      },
                    ],
                  })(
                    <Select
                      style={{ width: '100%' }}
                      mode="combobox"
                      onChange={this.handleChange.bind(this)}
                      filterOption={false}
                      placeholder="E.g. Barista"
                    >
                      <OptGroup label="Use a Workstream job description">
                        {this.state.options}
                      </OptGroup>
                    </Select>
                  )}
                </FormItem>
              </Flex>
              <Box mt={28} />
              <GradientButton
                disabled
                rightArrow
                onClick={this.handleClickSignup.bind(this)}
                loading={this.state.isSubmitting}
              >
                Add my first job
              </GradientButton>
              <Flex mt={30}>
                <Text>
                  Do you have an account? <a href={`${HRHOST}/#/login`}> Log in</a>
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export const changeQueryString = (searchString, documentTitle, noTrack) => {
  documentTitle = typeof documentTitle !== 'undefined' ? documentTitle : document.title;
  const urlSplit = window.location.href.split('?');
  const obj = { Title: documentTitle, Url: urlSplit[0] + searchString };
  window.history.pushState(obj, obj.Title, obj.Url);
  if (window.analytics && !noTrack) {
    // track URL change using segment
    window.analytics.page({ url: window.location.href });
  }
};

export default Form.create()(Signup);
